import { isEmpty } from 'lodash';

import { isPossiblePhoneNumber } from '../is-possible-phone-number/is-possible-phone-number';

import { RoutableNumberType } from './routable-number-type';

export const getRoutableNumberType = (input: string): RoutableNumberType | undefined => {
  if (isEmpty(input)) {
    return undefined;
  }

  if (isPossiblePhoneNumber(input)) {
    return RoutableNumberType.e164Phone;
  }

  if (input.match(/^client:.*/)) {
    return RoutableNumberType.clientSoftPhone;
  }

  return undefined;
};
